// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"a310be7f","333":"0e3deb52","426":"9fded4f6","524":"04f58e88","570":"2c52803e","573":"6c9cf19e","787":"1724e264","815":"3fcbe516"}[chunkId] + ".chunk.js";
};